import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var AccordionItem = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, _b = _a.tag, Tag = _b === void 0 ? 'div' : _b, attributes = __rest(_a, ["children", "className", "disabled", "tag"]);
    return (jsx(Tag, __assign({}, attributes, { className: classNames('accordion-item', className, disabled && 'disabled'), "data-testid": "accordion-item" }, { children: children })));
};
AccordionItem.displayName = 'Accordion.Item';

export { AccordionItem };
